



























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LectureVideoCreate as ILectureVideoCreate } from "@/api/models/lecture-video-create";
import { LectureVideoEdit as ILectureVideoEdit } from "@/api/models/lecture-video-edit";
import { LectureVideo as ILectureVideo } from "@/api/models/lecture-video";
import draggableComponent from "vuedraggable";
import api from "@/getinfo-api";
import EditorWithFile from "@/components/EditorWithFile.vue";

@Component({
  components: { EditorWithFile, draggableComponent }
})
export default class LectureVideoCreate extends Vue {
  @Prop() lectureId!: string;
  @Prop() existVideos?: undefined | Array<ILectureVideo>;
  addedVideosToArray: Array<ILectureVideoCreate | ILectureVideo> = []; //ЭТО ДОБАВЛЕННЫЕ ВИДЕО КОТОРЫЕ ВИСЯТ В СПИСКЕ
  lectureVideoTitle!: string | undefined; // ЭТО TITLE, СТРОКА ВВОДА НАЗВАНИЯ ВИДЕО
  body!: any;
  index!: number | undefined;
  selectedVideoId!: string | undefined; // ЦЕПЛЯЕТСЯ ЗА ЩАБЛОН РЕДАКТИРОВАНИЯ ИЛИ СОЗДАНИЯ
  deleteVideoArray: Array<ILectureVideo> = [];
  showSpinner: boolean = false;
  data() {
    return {
      body: undefined,
      selectedVideoId: undefined, // ЦЕПЛЯЕТСЯ ЗА ЩАБЛОН РЕДАКТИРОВАНИЯ ИЛИ СОЗДАНИЯ
      index: undefined,
      lectureVideoTitle: undefined // ЭТО ТАЙТЛ, СТРОКА ВВОДА НАЗВАНИЯ ВИДЕО
    };
  }

  //Учитывает сортировку
  applySort() {
    if (this.addedVideosToArray) {
      this.addedVideosToArray.forEach(
        (element: ILectureVideoCreate | ILectureVideo, index: number) => {
          element.sort = index + 1;
        }
      );
      this.$emit("sortSlide", this.addedVideosToArray);
    }
  }

  //Удаляет созданное видео
  deleteVideo(videos: any) {
    if (videos.id) {
      this.deleteVideoArray.push(videos.id);
      this.$emit("videoToDelete", this.deleteVideoArray);
    }
    this.addedVideosToArray = this.addedVideosToArray.filter((element: any) => {
      return element != videos;
    });
    this.$emit("sortSlide", this.addedVideosToArray);
  }

  //Создает видео
  createLectureVideo() {
    if (!this.index && this.index !== 0) {
      let info: ILectureVideoCreate = {
        title: this.lectureVideoTitle
          ? this.lectureVideoTitle
          : this.$tc(this.$translate.Untitled),
        sort: this.addedVideosToArray.length + 1,
        body: this.body
      };
      this.addedVideosToArray.push(info);
    } else {
      //@ts-ignore
      this.addedVideosToArray[this.index].title = this.lectureVideoTitle;
      this.addedVideosToArray[this.index].body = this.body;
    }

    this.$emit("createLectureVideo", this.addedVideosToArray);
    this.hideModal();
  }

  hideModal() {
    this.$bvModal.hide("createVideo");
    this.body = undefined;
    this.lectureVideoTitle = undefined;
    this.selectedVideoId = undefined;
    this.index = undefined;
  }

  //Редактирует видео во вкладке редактирования
  editVideo() {
    if (this.selectedVideoId && this.index !== undefined) {
      let params: ILectureVideoEdit = {
        body: this.body,
        title: this.lectureVideoTitle
      };
      api.LectureVideoApi.edit(
        this.$route.params.id,
        this.selectedVideoId,
        params
      ).then((res: { data: ILectureVideo }) => {
        if (this.index !== undefined) {
          this.addedVideosToArray[this.index].title = res.data.title;
          this.hideModal();
        }
      });
    }
  }

  triggerEditSlideModal(item: any, index: number) {
    this.$bvModal.show("createVideo");
    this.index = index;
    if (item.id) {
      this.showSpinner = true;
      this.selectedVideoId = item.id;
      api.LectureVideoApi.get(this.$route.params.id, item.id)
        .then((res: { data: ILectureVideo }) => {
          this.body = res.data.body;
          this.lectureVideoTitle = res.data.title;

          if (res.data.id) {
            this.lectureVideoTitle = res.data.title;
            this.body = res.data.body;
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      this.body = item.body;
      this.lectureVideoTitle = item.title;
    }
  }

  //Открыть модалку нажав на кнопку "Добавить"
  showModalAddPage() {
    this.selectedVideoId = undefined;
    this.$bvModal.show("createVideo");
    this.body = "";
    this.lectureVideoTitle = "";
  }

  mounted() {
    if (this.existVideos) {
      this.addedVideosToArray = this.existVideos;
    }
  }
}
